var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-header table-staffing" }, [
    _c("div", { staticClass: "dt-content" }, [
      _c("div", { staticClass: "dt-header", attrs: { id: "dt-header" } }, [
        _c(
          "div",
          {
            staticClass: "header-col padding-left-27px",
            style: {
              width: _vm.columnWidth.firstName.size
                ? _vm.columnWidth.firstName.size + "px"
                : "10%"
            },
            attrs: { id: "firstName" },
            on: {
              click: function($event) {
                _vm.setSortOption("firstName")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("firstName", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              first name\n              "),
                    this.pagingObj.sortType != "firstName"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "firstName" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "firstName" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.lastName.size
                ? _vm.columnWidth.lastName.size + "px"
                : "10%"
            },
            attrs: { id: "lastName" },
            on: {
              click: function($event) {
                _vm.setSortOption("lastName")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("lastName", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "content no-select" }, [
                  _vm._v("\n              last name\n              "),
                  _c(
                    "span",
                    [
                      this.pagingObj.sortType != "lastName"
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "lastName" &&
                      this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort-up" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "lastName" &&
                      !this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort-down" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.email.size
                ? _vm.columnWidth.email.size + "px"
                : "16%"
            },
            attrs: { id: "email" },
            on: {
              click: function($event) {
                _vm.setSortOption("email")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("email", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              email\n              "),
                    this.pagingObj.sortType != "email"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "email" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "email" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.phoneNumber.size
                ? _vm.columnWidth.phoneNumber.size + "px"
                : "8%"
            },
            attrs: { id: "phoneNumber" },
            on: {
              click: function($event) {
                _vm.setSortOption("phone")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("phoneNumber", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              phone number\n              "),
                    this.pagingObj.sortType != "phone"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "phone" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "phone" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.role.size
                ? _vm.columnWidth.role.size + "px"
                : "14%"
            },
            attrs: { id: "role" },
            on: {
              click: function($event) {
                _vm.setSortOption("role")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("role", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              role\n              "),
                    this.pagingObj.sortType != "role"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "role" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "role" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.events.size
                ? _vm.columnWidth.events.size + "px"
                : "10%"
            },
            attrs: { id: "events" },
            on: {
              click: function($event) {
                _vm.setSortOption("events")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("events", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              events\n              "),
                    this.pagingObj.sortType != "events"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "events" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "events" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.events.size
                ? _vm.columnWidth.payRates.size + "px"
                : "8%"
            },
            attrs: { id: "payRates" },
            on: {
              click: function($event) {
                _vm.setSortOption("payRates")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("payRates", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              hourly rate\n              "),
                    this.pagingObj.sortType != "payRates"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "payRates" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "payRates" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.events.size
                ? _vm.columnWidth.address.size + "px"
                : "20%"
            },
            attrs: { id: "address" },
            on: {
              click: function($event) {
                _vm.setSortOption("address")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("address", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              address\n              "),
                    this.pagingObj.sortType != "address"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "address" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "address" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.actions.size
                ? _vm.columnWidth.actions.size + "px"
                : "4%"
            },
            attrs: { id: "actions" }
          },
          [_vm._m(0)]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-container" }, [
      _c("div", { staticClass: "crop" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1259bebc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1259bebc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/staffing/StaffingHeader.vue
// module id = 2087
// module chunks = 1